<template>
  <div class="room-icon-checkboxes">
    <label
      v-for="item in list"
      :key="item.code"
      class="room-icon-checkboxes__item"
    >
      <input
        v-model="checked_list"
        :value="item"
        type="checkbox"
        @change="$emit('change', checked_list)"
        name="accomodation-type"
      />
      <span
        class="room-icon-checkboxes__checkmark"
        :class="{ 'room-icon-checkboxes__checkmark--checked': checked_list.find(checked_item => checked_item.code === item.code) }"
      >
        <template v-for="(adult, index) in item.age_assignment.adult">
          <img v-if="adult" src="@/assets/img/adult-icon.svg" alt="" :key="`adult_${index}`">
        </template>
        <template v-for="(adult, index) in item.age_assignment.teenager">
          <img v-if="adult" src="@/assets/img/teenager-icon.svg" alt="" :key="`teenager_${index}`">
        </template>
        <template v-for="(adult, index) in item.age_assignment.child">
          <img v-if="adult" src="@/assets/img/child-icon.svg" alt="" :key="`child_${index}`">
        </template>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppRoomIconCheckboxes',
  props: {
    list: Array,
  },
  data() {
    return {
      checked_list: []
    }
  },
  methods: {
    resetSearchResult() {
      this.checked_list = []
    }
  }
}
</script>

<style lang="sass" scoped>
.room-icon-checkboxes
  display: flex
  justify-content: flex-start
  align-items: center
  flex-wrap: wrap
  gap: 10px
  padding-top: 20px

  input
    +visually-hidden

.room-icon-checkboxes__checkmark
  display: inline-flex
  align-items: flex-end
  justify-content: center
  gap: 2px
  min-width: 38px
  height: 38px
  padding: 8px
  border: 1px solid rgba(0, 0, 0, 0.1)
  border-radius: 4px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1)
  background: linear-gradient(180deg, #fff 0%, #f4f4f4 100%)
  cursor: pointer
  transition: border 0.3s, background-color 0.3s

  &:hover
    border: 1px solid #bbb
    background-color: #f9f9f9

  &[disabled]
    pointer-events: none

.room-icon-checkboxes__checkmark--checked
  position: relative
  border: 1px solid #bbb
  background: #f1f1f1

  &:after
    content: ''
    position: absolute
    top: 3px
    right: 3px
    width: 5px
    height: 5px
    border-radius: 50%
    background-color: #ff9416

</style>